import { DefinedPropertyObject, IEntityMinimalModel } from "../../../api/GenericTypes";
import { GenericVirtualizedSelectFormField } from "../../../common/formfields/GenericVirtualizedSelectFormField/GenericVirtualizedSelectFormField";
import { EntityFilterSideBar } from "../../../common/sidebar/filtersidebar/EntityFilterBar";
import {
  TabStoreFilterSidebarProps,
  TabStoreFilterFormProvider,
} from "../../../common/sidebar/filtersidebar/TabStoreFilterFormProvider";
import {
  CombinedModificationRecordEntityDefaultFormValues,
  combinedModificationRecordEntityFiltersToForm,
  combinedModificationRecordEntityFormToFilters,
  ICombinedModificationRecordEntityForm,
} from "../../../common/sidebar/filtersidebar/GenericFilters/CombinedModificationRecordEntityFilterFormModels";
import {
  CustomFieldTemplate,
  CustomFieldTemplateFilters,
  CustomFieldTemplateLabels,
} from "../../../api/CustomFields/CustomFieldTemplates";
import {
  AbstractedCustomFieldDataTypes,
  AbstractedCustomFieldDataTypesConsts,
  abstractedDataTypeToFilter,
  generateAbstractedFromDataType,
} from "../../CustomFields/CustomFieldUtils";
import { AbstractedCustomFieldDataTypeIcon } from "../../CustomFields/CustomFieldRenderUtils";
import { CustomTypeTemplatesVirtualizedSelectForm } from "../../../common/forms/EntityForms/formsVirtualized/CustomTypeTemplatesVirtualizedSelectForm";
// import { CustomTypeTemplatePackagesVirtualizedSelectForm } from "../../../common/forms/EntityForms/formsVirtualized/CustomTypeTemplatePackagesVirtualizedSelectForm";

export interface CustomFieldTemplateFilterForm extends ICombinedModificationRecordEntityForm {
  dataType?: AbstractedCustomFieldDataTypes[] | undefined | null;
  customTypeTemplateIds?: IEntityMinimalModel[] | undefined | null;
  customTypeTemplatePackageIds?: IEntityMinimalModel[] | undefined | null;
}
const defaultValues: DefinedPropertyObject<CustomFieldTemplateFilterForm> = {
  dataType: null,
  customTypeTemplateIds: null,
  customTypeTemplatePackageIds: null,
  ...CombinedModificationRecordEntityDefaultFormValues,
};
export const customFieldFormToFilters = (form: CustomFieldTemplateFilterForm): CustomFieldTemplateFilters => {
  let filters: CustomFieldTemplateFilters = {
    ...combinedModificationRecordEntityFormToFilters(form),
  };
  filters.dataTypes =
    Array.isArray(form.dataType) && form.dataType.length > 0
      ? form.dataType?.map((d: AbstractedCustomFieldDataTypes) => abstractedDataTypeToFilter(d)).flat()
      : null;
  filters.customTypeTemplateIds =
    Array.isArray(form.customTypeTemplateIds) && form.customTypeTemplateIds.length > 0
      ? form.customTypeTemplateIds?.map((d) => d.id)
      : null;
  filters.customTypeTemplatePackageIds =
    Array.isArray(form.customTypeTemplatePackageIds) && form.customTypeTemplatePackageIds.length > 0
      ? form.customTypeTemplatePackageIds?.map((d) => d.id)
      : null;
  return filters;
};
/**
 * Converts CustomFieldTemplateFilters to CustomFieldTemplateFilterForm
 * @param filters CustomFieldTemplateFilters
 * @returns CustomFieldTemplateFilterForm
 * @author @CorradoSurmanowicz
 */
export const customFieldTemplateFiltersToForm = (
  filters: CustomFieldTemplateFilters
): CustomFieldTemplateFilterForm => {
  return {
    dataType: filters.dataTypes
      ? (filters.dataTypes
          .map((dataType) => generateAbstractedFromDataType(dataType).abstractedDataType)
          .filter((v) => v) as AbstractedCustomFieldDataTypes[])
      : null,
    ...combinedModificationRecordEntityFiltersToForm(filters),
  };
};

const defaultFilters: CustomFieldTemplateFilters = { sortBy: [{ property: "NAME", sortDirection: "ASC" }] };

export const CustomFieldTemplatesFilterBar = ({
  initialValues,
  dispatchTabStore,
  onFormChange,
  tabsLoading,
  currentTab,
}: TabStoreFilterSidebarProps<CustomFieldTemplate, CustomFieldTemplateFilterForm, CustomFieldTemplateFilters>) => {
  return (
    <TabStoreFilterFormProvider
      tabsLoading={tabsLoading}
      initialValues={initialValues}
      defaultValues={defaultValues}
      defaultFilters={defaultFilters}
      formToFilters={customFieldFormToFilters}
      onFormChange={onFormChange}
      dispatchTabStore={dispatchTabStore}
    >
      {({ control, onReset }) => (
        <EntityFilterSideBar onReset={onReset}>
          <GenericVirtualizedSelectFormField
            id={"dataType"}
            label={CustomFieldTemplateLabels.dataType}
            items={AbstractedCustomFieldDataTypesConsts.map((e) => e)}
            control={control}
            placeholder={"Select data type"}
            onRowStartRenderer={(row) => <AbstractedCustomFieldDataTypeIcon dataType={row} />}
            isMulti
          />

          <CustomTypeTemplatesVirtualizedSelectForm
            id="customTypeTemplateIds"
            control={control}
            showControls={false}
            isMulti
          />

          {/* <CustomTypeTemplatePackagesVirtualizedSelectForm
            id="customTypeTemplatePackageIds"
            control={control}
            showControls={false}
            isMulti
          /> */}
        </EntityFilterSideBar>
      )}
    </TabStoreFilterFormProvider>
  );
};
